// Watch grid events

export const getOriginLevel2 = globalCategory => {
  switch (globalCategory) {
    case "category-classic":
      return "classic"
    case "category-pro":
      return "professional"
    default:
      return "default"
  }
}

export const sendWatchGridEvent = async (organizationId, accessToken, event, data) => {
  // get the visitorId from cookies
  const cookies = document.cookie.split(";")
  const visitorIdCookie = cookies.find(c => c.includes("coveo_visitorId"))
  data.clientId = visitorIdCookie?.split("=")[1]
  data.documentTitle = document?.title

  const watchGridEventsUrl = `https://${organizationId}.analytics.org.coveo.com/rest/ua/v15/analytics/${event}`
  const res = await fetch(`${watchGridEventsUrl}`, {
    method: "post",
    body: JSON.stringify(data),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  })
  const json = await res.json()
}
